export const environment = {
	app: 'C4',
	production: true,
	firebase: {
		apiKey: 'AIzaSyAcHHeavmanzoIv4jdJq6dZOYBOAcAWY8U',
		authDomain: 'c4-notifications.firebaseapp.com',
		databaseURL: 'https://c4-notifications.firebaseio.com',
		projectId: 'c4-notifications',
		storageBucket: 'c4-notifications.appspot.com',
		messagingSenderId: '24377137300',
		appId: '1:24377137300:web:73a00c0aab8531e79afc81',
	},
	apiBaseUrl: 'https://c4-backend.cargochief.com',
	SEGMENT_KEY: 'HbSSxDHje59i0IbwrWo26U1k0VsPFEco',
	redux: {
		sessionUpdateMinutes: 5,
	},
	webSocket: {
		reconnectTimeIntervalSeconds: 10,
		endpoint: 'wss://ws.cargochief.com',
		debugMode: false,
		enabled: true,
		sessionUpdateMinutes: 5,
	},
	GOOGLE_API_KEY: 'AIzaSyDDQ0PtQxFZQFP6pAopi86IbTfMjDXEnkM',
	environment: 'prod',
	TRUCK_SEARCH_COUNTRY: ['us', 'ca', 'mx'],
	BULK_MATCH_CONFIG: {
		load: {
			bucketName: 'cargochief-bulk-capacity-match',
		},
		project: {
			bucketName: 'cargochief-bulk-project',
		},
		priceLane: {
			bucketName: 'lanemaster-price-lanes-prod',
		},
	},
	PRICING_DATA_CONFIG: {
		bucketName: 'mcleod-loads-prod',
	},
	LANE_MASTER_BASE_URL: 'https://app.lanemaster.com',
	NO_OF_SEARCH_RESULTS_TO_DISPLAY: 400,
	CAPACITY_SEARCH_THRESHOLD: 25,
	MILES_PER_DAY: 650,
	STRIPE_PUBLISHABLE_KEY: 'pk_live_tIhH0U6y4AuAdiYCtM2tIDCk',
	CARRIER_TRAILER_TYPE: true,
	INTERCOM_APP_ID: 'agws3dki',
	PROJECT_FEATURES: {
		PROBABILITY: true,
		CADENCE: false,
	},
	RECENT_TRANSACTION_AGE: 90,
	SHOW_DEADHEAD_MSG: true,
	PRICING_FEEDBACK_LIMIT: 5,
	CARRIER_LANES_VIEW: true,
	PRICE_LANES_BUTTON_ENABLED: true,
	CUSTOMERS_VIEW: true,
	SCORECARDS: true,
	SCORECARDS_PAGE_SIZE: 50,
	CARRIER_RATES: true,
	INTEGRATIONS: true,
	RFP_PREVIEW_TABLE_ROWS_LIMIT: 5,
	RFP_LANES_LIMIT: 500,
	SCORECARD_ACTIONS: true,
	PAYMENT_TRANSIT_DAYS: 2,
	SHOW_CARRIER_UPLOAD_TO_USER: true,
	SHOW_NOTIFICATIONS: true,
	ACTIVE_INTEGRATIONS: [
		'MY_CARRIER_PACKETS',
		'BLUE_YONDER',
		'MCLEOD',
		'TAI',
		'OMNIS',
		'THREE_PL_SYSTEMS',
		'FMS',
		'LOGISTICALLY',
		'ALJEX',
		'TURVO',
		'BROKER_PRO',
		'RMIS',
		'GREEN_SCREENS',
		'REVENOVA',
		'HIGHWAY',
		'CUSTOM',
	],
	MCLEOD_WEBHOOK: 'https://mcleod.cargochief.com/webhook',
	MERCURY_GATE_WEBHOOK: 'https://mercurygate.cargochief.com',
	TAI_WEBHOOK: 'https://tai.cargochief.com',
	OMNIS_WEBHOOK: 'https://omnis.cargochief.com',
	THREE_PL_SYSTEMS_WEBHOOK: 'https://3pl-systems.cargochief.com',
	FMS_WEBHOOK: 'https://fms.cargochief.com',
	LOGISTICALLY_WEBHOOK: 'https://logistically.cargochief.com',
	TURVO_WEBHOOK: 'https://turvo.cargochief.com',
	BROKER_PRO_WEBHOOK: 'https://broker-pro.cargochief.com',
	REVENOVA_WEBHOOK: 'https://revenova.cargochief.com',
	FREE_TRIAL_DAYS: 0,
	clientUrl: 'https://c4.cargochief.com/#/',
	// CN-8597 — hecate direct-auth cutover (prod, enabled 2026-06-01). The
	// c4-client confidential OAuth row is provisioned in hecate-prod with
	// resource_ids="C4" (c4's HecateJwtValidator requires aud to contain "C4";
	// janus/plutus reject it — the intended security boundary). Set
	// AUTH_CLIENT_SECRET below to the plaintext that was bcrypted into that row.
	// NOTE: this secret ships in the SPA bundle (user-recoverable) — an accepted
	// tradeoff pending a PKCE/BFF follow-up.
	AUTH_SERVER_URL: 'https://auth.cargochief.com',
	AUTH_CLIENT_ID: 'c4-client',
	AUTH_CLIENT_SECRET: 'E6U/g1r7qb5o+gJ+mO430dNemo/Zak28',
	USE_HECATE_LOGIN: true,
	MINIMUM_SEATS: 2,
	CARRIER_BIDDING: false,
	TEAMS_CAPACITY: true,
	EMAIL_TEMPLATES: true,
	SEGMENT_PROXY: 'https://c4-seg-an.cargochief.com',
	EXCLUDE_BULK_CARRIER: true,
	CONFIDENCE_SCORE: true,
	rfp_pricing_loads_base_url: 'https://c4-accounts-prod.s3.us-west-1.amazonaws.com/',
	MINIMUM_MILES_PER_DAY: 300,
	V2_CARRIER_NETWORK_PAGE: false,

	AUTOMATION_TOOLS_ENABLED: true,
	BA_BOOK_NOW_ENABLED: true,
	PRIVATE_FLEETS_ENABLED: false,
	AUTHORIZED_API_CLIENTS_ENABLED: true,
	PRICING_INTEGRATION_ENABLED: true,
	AMAZON_DEVELOPER_APP_ID: '',
	AMAZON_FREIGHT_INTEGRATIONS_URL: '',
	LOGO_CONFIG: {
		bucketName: 'account-logo-prod',
	},
	LOADS_SOURCING_PAGE: true,
	TABLEAU_DASHBOARD_URL:
		'https://us-west-2b.online.tableau.com/t/cargochief/views/DFMDashboard_V2/ExecutiveDashboard/f64fa2a4-8cb5-4ecb-bc2d-cb6ca467554b/797024fd-e133-4e97-8ad8-c3ac7311e1ba',
	TABLEAU_CUSTOMER_REPORT_URL: `https://us-west-2b.online.tableau.com/t/cargochief/views/Customer_DFMDashboard/ExecutiveDashboard`,
	ENABLE_ENGAGED_TAB_ON_PROJECT_DETAILS: true,
	PROJECT_GROUPS_ENABLED: true,
	LOAD_OFFER_BATCH_TEMPLATE_ENABLED: true,
	SHOW_QUALITY: true,
	HIGH_QUALITY: 80,
	MEDIUM_QUALITY: 49, // CN-8747: >49 so a Moderate vetting-only score (50) reads Medium, not Low
	// Hours
	VETTING_TIME_THRESHOLD: 48,
	// Months
	TRANSACTIONS_LOOKUP_WINDOW: 3,
	SHOW_QUALITY_IN_BIDS_TABLE: false,
	ADDITIONAL_LOADS_PROJECT_TYPES: 'PROCURED,WATERFALL',
	FEATURE_FLAGS: {
		PROCURED_CARRIERS_EMAIL: true,
		V2_BIDDING_LAYOUT_ENABLED: true,
		CARRIER_REGISTRATION_ENABLED: true,
		CARRIER_QUICK_SEARCH_DISABLED: true,
		CARRIER_NAVBAR_MENU: {
			DASHBOARD: false,
			AVAILABLE_LOADS: true,
			BOOKED_LOADS: true,
			OFFERS: false,
			QUALITY_SCORE: false,
			NETWORK: false,
			PROFILE: false,
			// CN-8556 — keep off in prod until v2.3 ships end-to-end. Toggle
			// on per the v2.3 release plan.
			DISCOVER: false,
		},
		LOADS_SOURCING_EQUIPMENTS: 'van,flatbed,reefer',
		REGISTER_SINGLE_ACCOUNT_PER_MC_DOT: true,
		CARRIER_REGISTRATION_VALIDATION_ENABLED: true,
		CARRIER_REGISTRATION_EMAIL_EXPIRATION_MINUTES: 15,
		CARRIER_NOTIFICATIONS_ENABLED: true,
		SHOW_LOAD_TYPE_DROPDOWN: true,
		SPLIT_PROJECTS_MENU_ENABLED: true,
		// Demo-account data override (CN-9038). See environment.ts (the same
		// DEMO_ACCOUNT_OVERRIDE block) for the full doc, including the
		// read-only-by-construction rule. Keep this block IDENTICAL across all
		// five environment files.
		//
		// Live in prod deliberately (CN-9038): the demo account IS a production
		// account and the demo is given in prod, so the override has to work
		// there or the demo shows empty reports. Four of the five keys this
		// replaces were already live in prod; only the carrier-usage one was
		// empty here ("No overrides needed in production"), which is what made
		// prod's Carrier Usage demo behave differently from every other report.
		// The override is inert for every account not listed below.
		DEMO_ACCOUNT_OVERRIDE: {
			ENABLED: true,
			// demo account id -> source production account whose data it reads
			ACCOUNT_OVERRIDES: {
				'5876': '7829', // Demo Account -> WSI
			},
			// demo account id -> a user inside the source account, for non-admin demo users
			USER_OVERRIDES: {
				'5876': '8034', // User ID from account 7829 (has 9403 loads)
			},
		},
		OFFER_ANALYTICS_NON_ADMIN_ENABLED: true,
		LANE_ANALYSIS_DASHBOARD_ENABLED: true,
		LANE_CARRIER_ANALYTICS_ENABLED: false,
		// CN-9074 (Coverage / plan B6). OFF in prod until the plan's section 2.6
		// calibration reviews have run: Coverage Status is explicitly not a production
		// claim until it is calibrated (plan section 4), and every threshold behind it is
		// still at its uncalibrated default. Flip it when Kirk's review cycle signs off.
		COVERAGE_ENABLED: false,
		STRONG_LANES_ENABLED: true,
		CARRIER_LANE_BROKER_ACCOUNT_MAPPING_ENABLED: false,
		CARRIER_BOOKED_LOADS_V2: {
			SIDENAV_ENABLED: true,
			ACTIONS: {
				ENABLED: true,
				DECLINE_ENABLED: false,
				UPDATE_OWNER_ENABLED: true,
			},
			MULTI_SELECT_ENABLED: true,
		},
		BA_LOAD_OWNER_UPDATE_BROKER_SETTING_EDITABLE: false,
		SHOW_NETWORK_ANALYSIS_ON_CARRIER_SIGNUP: true,
		BROKER_SEARCH_INPUT_ON_CARRIER_PROFILE: false,
		ENABLE_PWA: false,
		V2_TEAMS_MANAGE_USERS_PAGE_ENABLED: true,
		// Procurement page UX redesign - CN-8312
		PROCUREMENT_UX_V2: {
			ENABLED: false, // Disabled in prod until tested
			COLLAPSIBLE_HEADER: false,
			DRAG_DROP_ENHANCED: false,
			KANBAN_LAYOUT: false,
			RIGHT_RIBBON: false,
		},
		LOAD_COUNTRY_DISPLAY_ENABLED: false,
		// CN-8810: Canada lane pricing unsupported; recent transactions gated off
		// outside test.
		CANADA_ENABLED: false,
		MEXICO_ENABLED: false,
		CANADA_LANE_PRICING_ENABLED: false,
		MEXICO_LANE_PRICING_ENABLED: false,
	},
	CARRIER_LOADS_REFRESH_RATE: 60,
	CARRIER_WEB_SOCKET_THROTTLE_TIME: 0.25, // seconds
	RSA_PUBLIC_KEY: `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEArhb5BykShBf4m9oWCktB
kYHP40QFW2yV9CG4Hn8+j6Ji6QA95uO6C8kDYf6qJa6I3IyiNyv9Tjy15Cwo4EjW
6BQfYg7fKBP6OQCTuDXjAvYxYVPK/jlWO2XrJLG0x97bT8gYLRrFsXLwDb4HCUC7
43/OwOz5afB28Iv722gWxy0mxUJnDcTn28xuTJ9pGFdcfWyPnhGP9uEKGplo/c7a
wx9nklY/7NrTyFlkfUuAC2UgbMF21yOIp1A5o1bkvImcemRuQfsP57ubBSE/2/Me
hpbZhgyWkyr8oR1N8p3e79fsafTb58rOJGa5FPgpAmh1eF1Opbr5bD5R7dxdz5PD
4wIDAQAB
-----END PUBLIC KEY-----`,
};
